import { useState, useEffect, useCallback } from "react";
import DraggableDualList from "../DraggableDualList/DraggableDualList";
import GroupService from "../../services/GroupsService";

function makeItemId(group) {
   return `${group.id}`;
}

function buildTree(allGroups, selectedGroups, includeSelected) {
   const groupMap = new Map();

   for (const group of allGroups) {
      const belongsToGroup = selectedGroups.find(
         (ca) => ca.id === group.id
      );

      const shouldInclude = includeSelected ? !!belongsToGroup : !belongsToGroup;
      if (!shouldInclude) continue;

      const itemId = makeItemId(group);
      groupMap.set(itemId, {
         id: itemId,
         originalId: itemId,
         type: "item",
         label: group.name,
         icon: null,
      });
   }

   return Array.from(groupMap.values());
}
function flattenSelectedItems(rightTree) {
   const selected = [];
   for (const node of rightTree) {
      const items = node.type === "group" ? node.children : [node];
      for (const item of items) {
         if (item.type === "item") {
            selected.push({
               id: item.id,
               value: item.id,
               originalId: item.originalId,
               label: item.label,
            });
         }
      }
   }
   return selected;
}

export function GroupsDDL({ onChangeList, groups }) {
   const [allGroups, setAllGroups] = useState([]);
   const [initialLeft, setInitialLeft] = useState([]);
   const [initialRight, setInitialRight] = useState([]);
   const [ready, setReady] = useState(false);

   useEffect(() => {
      (async () => {
         try {
            const response = await GroupService.listGroups();
            if (response && response.data) {
               const data = response.data;
               setAllGroups(data);
            }
         } catch (error) {
            console.error(error);
         }
      })();
   }, []);

   useEffect(() => {
      if (!allGroups.length) return;

      const left = buildTree(allGroups, groups, false);
      const right = buildTree(allGroups, groups, true);

      setInitialLeft(left);
      setInitialRight(right);
      setReady(true);

      if (onChangeList) onChangeList(flattenSelectedItems(left), flattenSelectedItems(right));
   }, [allGroups]);

   const handleChange = useCallback(
      (leftTree, rightTree) => {
         if (onChangeList) onChangeList(flattenSelectedItems(leftTree), flattenSelectedItems(rightTree));
      },
      [onChangeList]
   );

   if (!ready) return null;

   console.log(initialLeft);
   console.log(initialRight);

   return (
      <DraggableDualList
         labelLeft="Grupos Disponíveis"
         labelRight="Grupos Selecionados"
         initialLeft={initialLeft}
         initialRight={initialRight}
         onChange={handleChange}
      />
   );
}